import { ContactBlock, CTABlock } from "../types/optimizely/blocks";

export const mapContactBlockToCTABlockProps = (
  contactBlock: ContactBlock
): CTABlock => {
  return {
    contentType: ["Block", "CallToActionBlock"],
    heading: contactBlock.title,
    buttonLink: contactBlock.link,
    introduction: { value: "", propertyDataType: "PropertyLongString" },
    linkText: contactBlock.text,
  };
};
